import { render } from "./TopBar.vue?vue&type=template&id=7bc764e5&scoped=true&ts=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=7bc764e5&scoped=true&lang=less"

import exportComponent from "/Users/fanglegefang/Desktop/Feiyi_sign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc764e5"]])

export default __exports__